var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-wrap"},[_c('StudentInfoForm',{attrs:{"student-data":_vm.addForm,"submit-btn-text":_vm.submitBtnText},on:{"save":_vm.saveHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }